module.exports = __webpack_public_path__ + "static/media/loader.6ac202fb.svg";